import validate from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/pages/runtime/validate.js";
import test_45global from "/opt/atlassian/pipelines/agent/build/middleware/test.global.ts";
import manifest_45route_45rule from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  test_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}